var map = {
	"./customer-management.svg": 75343,
	"./home.svg": 83398,
	"./logo.svg": 87556,
	"./message-channel-management.svg": 86805,
	"./message-release-management.svg": 55748,
	"./role-permisson.svg": 74043,
	"./system-dictionary.svg": 48697,
	"./system-log.svg": 11947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56262;